/* iter55n — Recent-imports strip for the Starter Templates admin panel.
 *
 * Renders the last N template-import audit rows so ops can see who
 * imported what and when. Sourced from
 * `template_import_history` via `/api/admin/starter-templates/import-history`.
 */
import React, { useEffect, useState } from 'react';
import { History, Loader2, UserRound } from 'lucide-react';
import { adminApi } from '@/lib/api';

const fmt = (iso) => {
  try { return new Date(iso).toLocaleString(undefined,
    { month: 'short', day: 'numeric', hour: '2-digit', minute: '2-digit' }); }
  catch { return iso; }
};

export default function ImportHistoryStrip({ refreshKey = 0 }) {
  const [entries, setEntries] = useState(null);
  useEffect(() => {
    let alive = true;
    adminApi.importHistory(10)
      .then((r) => { if (alive) setEntries(r?.entries || []); })
      .catch(() => { if (alive) setEntries([]); });
    return () => { alive = false; };
  }, [refreshKey]);

  if (entries === null) {
    return (
      <div className="flex items-center gap-2 text-[10.5px] text-muted-foreground"
           data-testid="import-history-strip-loading">
        <Loader2 className="h-3 w-3 animate-spin" /> Loading recent imports…
      </div>
    );
  }
  if (entries.length === 0) return null;
  return (
    <div className="rounded-md border border-border bg-panel-header/20 p-2"
         data-testid="import-history-strip">
      <div className="mb-1 flex items-center gap-1.5 text-[10.5px] font-semibold uppercase tracking-wider text-muted-foreground">
        <History className="h-3 w-3" /> Recent imports
      </div>
      <ul className="space-y-0.5 text-[11px]">
        {entries.map((e) => (
          <li key={e.id} className="flex items-baseline gap-2"
              data-testid={`import-history-entry-${e.id}`}>
            <UserRound className="h-2.5 w-2.5 text-muted-foreground" />
            <span className="font-mono-stat text-[10px] text-muted-foreground">{fmt(e.at)}</span>
            <span className="font-medium">{e.actor || 'admin'}</span>
            <span className="text-muted-foreground">{e.replaced ? 'updated' : 'imported'}</span>
            <span className="rounded-sm bg-secondary/60 px-1.5 py-0 text-[10px]">
              {e.template_name}
            </span>
            <span className="text-[9.5px] text-muted-foreground">
              · {e.chapters_count} beats
            </span>
          </li>
        ))}
      </ul>
    </div>
  );
}
